import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";
import { apiUrl } from "../../../config/config.js";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

const reverseTranslateKeys = (data) => {
	const reverseMap = {
		Correo: "email",
		Nombre: "name",
		Teléfono: "phone",
		ID: "id",
		Creado: "createdAt",
	};

	const normalized = {};
	for (const key in data) {
		const normalizedKey = reverseMap[key] || key;
		normalized[normalizedKey] = data[key];
	}
	return normalized;
};

function CustomersDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);
	console.log("DETILS DATA:", locationType);

	const [customer, setCustomer] = useState({});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	useEffect(() => {
		if (locationType === "edit" && data) {
			setCustomer(reverseTranslateKeys(data));
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!customer.name || !customer.email || !customer.phone) {
			Toast.fire({
				icon: "error",
				title: "Los campos obligatorios no pueden estar vacíos",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setCustomer((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;

		try {
			if (locationType === "add") {
				const response = await fetch(apiUrl + "/register", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(customer),
				});
				const responseData = await response.json();
				if (responseData.ok) {
					Toast.fire({ icon: "success", title: responseData.message, background: "#1e2836", color: "#fff" });
					window.history.back();
					return;
				} else {
					Toast.fire({ icon: "error", title: responseData.message, background: "#1e2836", color: "#fff" });
				}
			} else {
				await handleSubmit("update", "customers", customer);
			}
			navigate("/customers");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		await handleDelete(customer.id, "customers", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Cliente" : "Actualizar Cliente"}</h1>

				<InputText label="Nombre" value={customer.name || ""} setValue={(v) => handleInputChange("name", v)} />
				<InputText label="Teléfono" value={customer.phone || ""} setValue={(v) => handleInputChange("phone", v)} />
				<InputText label="Correo" value={customer.email || ""} setValue={(v) => handleInputChange("email", v)} />
				{/* <InputText label="ID Negocio" value={customer.businessId || ""} setValue={(v) => handleInputChange("businessId", v)} /> */}

				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/customers")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default CustomersDetails;
